import { memo, useState, useRef } from 'react'
import { getPathFromRouteId } from 'core/utils/route-utils'
import { RouteId } from 'core/routing/router/route-ids'
import { NavLink } from 'react-router'
import { HEADER_FORMATION, HEADER_MANAGEMENT_RULES } from 'core/constants/translations'
import { PopoverHeaderCountry } from '../popover/popover-header-country'
import { PopoverHeaderPreferences } from '../popover/popover-header-preferences'
import { trackAnalyticsEvent } from '../../../../core/hooks/useAnalytics'
import { useTranslation } from 'react-i18next'

const HeaderLinks = () => {
  const { t } = useTranslation()
  const [isOpenCountryPopover, setIsOpenCountryPopover] = useState<boolean>(false)
  const [isOpenPreferencesPopover, setIsOpenPreferencesPopover] = useState<boolean>(false)
  const buttonHeadersRef = useRef<HTMLButtonElement | undefined>()
  const buttonPreferencesRef = useRef<HTMLButtonElement | undefined>()

  const activeStyle = {
    backgroundColor: '#EFF1F3'
  }

  return (
    <div className="mg-header-links">
      <NavLink
        className="mg-button-header"
        to={getPathFromRouteId(RouteId.School)}
        style={({ isActive }) => (isActive ? activeStyle : undefined)}
        onClick={() => {
          trackAnalyticsEvent('click_navbar_formation')
        }}
        end
      >
        <div className="mg-button-header__icon">
          <span className="material-icons-outlined notranslate">school</span>
        </div>
        <span className="mg-button-header__text">{t(HEADER_FORMATION)}</span>
      </NavLink>

      <NavLink
        className="mg-button-header"
        to={getPathFromRouteId(RouteId.Document)}
        style={({ isActive }) => (isActive ? activeStyle : undefined)}
        onClick={() => {
          trackAnalyticsEvent('click_navbar_management_rules')
        }}
        end
      >
        <div className="mg-button-header__icon" id="headerIcon">
          <span className="material-icons-outlined notranslate">help_outline</span>
        </div>
        <span className="mg-button-header__text">{t(HEADER_MANAGEMENT_RULES)}</span>
      </NavLink>
      <PopoverHeaderPreferences
        isOpenPopover={isOpenPreferencesPopover}
        setIsOpenPopover={setIsOpenPreferencesPopover}
        buttonRef={buttonPreferencesRef}
      />

      <PopoverHeaderCountry
        isOpenPopover={isOpenCountryPopover}
        setIsOpenPopover={setIsOpenCountryPopover}
        buttonRef={buttonHeadersRef}
      />
    </div>
  )
}

export default memo(HeaderLinks)
